<script setup lang="ts">
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import UIIconButton from '../ui/UIIconButton.vue';

import { useSearchStore } from '@/stores/searchStore'

const search = useSearchStore()

defineEmits(['clear']);
const props = defineProps<{
  placeholder: string
}>();
</script>
<template>
  <div class="relative flex items-center w-full">
    <MagnifyingGlassIcon
      class="mr-[14px] h-[18px] min-w-[18px] text-gpx_gray-600"
    />
    <input
      ref="inputRef"
      :placeholder="placeholder"
      v-model="search.query"
      type="text"
      class="form-input w-full border-none py-0 text-lgmx_19 font-semibold leading-7 text-gpx_black-50 placeholder:text-gpx_slate-700 focus:ring-transparent"
    />
    <UIIconButton icon="XMarkIcon" @click="search.query = ''; $emit('clear')" />
  </div>
</template>
